import { NAME } from './constants';

export const REGISTER_START = `${NAME}/REGISTER_START`;
